export type TimeRange = "1D" | "1W" | "1M" | "6M" | "1Y";

/** 🗓️ Date range calculation */
export const getDateRange = (timeRange: TimeRange) => {
  const endDate = new Date();
  const startDate = new Date();

  switch (timeRange) {
    case "1D":
      startDate.setHours(0, 0, 0, 0);
      break;
    case "1W":
      startDate.setDate(endDate.getDate() - 7);
      break;
    case "1M":
      startDate.setDate(endDate.getDate() - 30);
      break;
    case "6M":
      startDate.setMonth(endDate.getMonth() - 6);
      break;
    case "1Y":
      startDate.setFullYear(endDate.getFullYear() - 1);
      break;
  }

  return {
    startDate: startDate.toISOString(),
    endDate: endDate.toISOString(),
  };
};
